// extracted by mini-css-extract-plugin
export var standaloneTable = "_fj-0";
export var withExtraHeader = "_fj-1";